export enum NotePageTypeEnum {
  CANDIDATE = 'candidate',
  TALENT_POOL = 'talent-pool',
  JOB = 'job',
}
